import React, { useContext, useEffect, useRef, useState } from "react";
import { SearchIcon } from "../../../assets/icon/IconCollection"; // Import your search icon here
import { Avatar, SafeSendLogo } from "../../../assets/svg/SVGIconsCollection";
import { NavigationMenuContext } from '../../../store/side-menu-navigation-context';
import { useAppSelector } from "../../hooks/redux-hooks";
import LogoutModal from "../logout/LogoutModal";
import { menuData, MenuItem } from "../side-menu/MenuData";
import "./Header.scss";
import Searchbar from "./Searchbar";

interface HeaderProps {
  onMenuClick: (item: MenuItem) => void;
  activeItem: { item: MenuItem } | undefined;
}

const SearchMenu = (menu: MenuItem, query: string, resultArray: MenuItem[]) => {
  if (menu.items === undefined || menu.items.length == 0) {
    if (menu.title.length > 0 &&
      menu.path?.length !== undefined && menu.path?.length > 0 &&
      menu.title.toLowerCase().includes(query.toLowerCase())
    ) {
      resultArray.push(menu);
    }
  } else {
    menu.items?.map((menuItem, index) => {
      SearchMenu(menuItem, query, resultArray);
    });
  }
}
const Header: React.FC<HeaderProps> = (props) => {
  const popoverRef = useRef<HTMLDivElement>(null);
  const avaterRef = useRef<HTMLDivElement>(null);
  const [searchResult, setSearchResult] = useState<MenuItem[]>([]);
  const [showLogoutOption, setShowLogoutOption] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const { handleNavigationChange, clearMenuSelection } = useContext(NavigationMenuContext);
  const { given_name }: any = useAppSelector(
    (state: AppState) => state.authReducer?.authentication.user.profile
  );

  const { user }: any = useAppSelector(
    (state: AppState) => state.authReducer?.authentication
  );
  console.log(user);

  const onMenuClick = (item: MenuItem | undefined) => {
    if (item) {
      props.onMenuClick(item);
      if (item.path) {
        clearMenuSelection();
        let level = 'root';
        let panel = 'root';
        item.path.split('/').forEach((path) => {
          panel = panel + '-' + path;
          handleNavigationChange(level, panel);
          level = level + '-' + path;
        });
      }
    }
  };

  const handleSearch = (query: string) => {
    if (query.length > 0) {
      let resultArray: MenuItem[] = [];
      menuData.map((menuItem, index) => {
        SearchMenu(menuItem, query, resultArray);
      })
      if (resultArray && resultArray.length === 0) {
        resultArray.push({ title: 'No Records found!' });
      }
      setSearchResult(resultArray);
    }
    else {
      setSearchResult([]);
    }
  };

  const onRestApiClick = () => {
    onMenuClick(menuData[0]?.items[0]?.items[0]);
  };

  const onWebhooksClick = () => {
    onMenuClick(menuData[1]?.items[0]?.items[0]);
  };

  const onAvatarClick = () => {
    setShowLogoutOption((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target as Node) &&
      avaterRef.current &&
      !avaterRef.current.contains(event.target as Node)
    ) {
      setShowLogoutOption(false);
    }
  };

  const onLogoutClick = () => {
    setShowLogoutModal(true);
    setShowLogoutOption(false);
  }

  const onToggle = (value: boolean) => {
    setShowLogoutModal(value);
  }

  useEffect(() => {
    if (showLogoutOption) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showLogoutOption]);


  return (
    <header className="sticky-header">
      <div className="left-child">
        <SafeSendLogo />
        <div>Developer</div>
      </div>
      <div className="search-bar">
        <Searchbar
          icon={<SearchIcon />}
          onSearch={handleSearch}
          searchResult={searchResult}
          onMenuClick={onMenuClick}
        />
      </div>
      <div className="options">
        <ul className="centered-list">
          <li onClick={onRestApiClick} className="header-List-Item">
            REST APIs
          </li>
          <li onClick={onWebhooksClick} className="header-List-Item">
            Webhooks
          </li>
        </ul>
      </div>
      <div className="account-logo" onClick={onAvatarClick} ref={avaterRef} data-testid="21e999e8-b9f5-4675-bc57-6cb2755c6082">
        <Avatar color={showLogoutOption ? "#669440" : "#565A5E"} />
      </div>

      {showLogoutOption && (
        <div className="logout-popover" ref={popoverRef}>
          <div className="user-name">Hi, {given_name}!</div>
          <hr className="divider"></hr>
          <div className="logout" onClick={onLogoutClick}>
            Log Out
          </div>
        </div>
      )}

      <LogoutModal onToggle={onToggle} show={showLogoutModal}></LogoutModal>
    </header>
  );
};

export default Header;
